//import * as types from '../actions/types';
import * as types from './actionTypes';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case types.GET_REPORT_SUCCESS:
      return { ...state, loading: false, data: action.data };

    case types.GET_REPORT_FAILED:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
}
